import { ChartManager } from "..";

/**
 * Classe gerenciadora dos gráficos evolutivos de cruzamentos.
 */
export class EvolutiveCrossChartManager extends ChartManager {
  constructor(instance) {
    super(instance);
  }
}